var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOauthLogoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.52 12.2727C23.52 11.4218 23.4436 10.6036 23.3018 9.81816H12V14.46H18.4582C18.18 15.96 17.3345 17.2309 16.0636 18.0818V21.0927H19.9418C22.2109 19.0036 23.52 15.9273 23.52 12.2727Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C15.24 24 17.9564 22.9255 19.9418 21.0927L16.0637 18.0818C14.9891 18.8018 13.6146 19.2273 12 19.2273C8.87456 19.2273 6.22911 17.1164 5.28547 14.28H1.27638V17.3891C3.25093 21.3109 7.30911 24 12 24Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28545 14.28C5.04545 13.56 4.90909 12.7909 4.90909 12C4.90909 11.2091 5.04545 10.44 5.28545 9.71998V6.61089H1.27636C0.463636 8.23089 0 10.0636 0 12C0 13.9363 0.463636 15.7691 1.27636 17.3891L5.28545 14.28Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.77273C13.7618 4.77273 15.3437 5.37818 16.5873 6.56727L20.0291 3.12545C17.9509 1.18909 15.2346 0 12 0C7.30911 0 3.25093 2.68909 1.27638 6.61091L5.28547 9.72C6.22911 6.88364 8.87456 4.77273 12 4.77273Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOauthLogoGoogle);
export default __webpack_public_path__ + "static/media/oauth-logo-google.420169f299402ff6bd627eeff16bad0d.svg";
export { ForwardRef as ReactComponent };